import { createRouter, createWebHistory } from "vue-router";
import Login from "@/views/Login.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import DefaultLayoutPublico from "@/layouts/DefaultLayoutPublico.vue";
import { useAuthStore } from "@/stores/auth";

// Views públicas
import Home from "@/views/Home.vue";
import CategoriaProdutos from "@/views/CategoriaProdutos.vue";
import ManualProduto from "@/views/ManualProduto.vue";

// Views administrativas - lazy loading
const AdminCategorias = () => import("@/views/admin/AdminCategorias.vue");
const AdminCategoria = () => import("@/views/admin/AdminCategoria.vue");
const AdminProdutos = () => import("@/views/admin/AdminProdutos.vue");
const AdminProduto = () => import("@/views/admin/AdminProduto.vue");
const AdminManual = () => import("@/views/admin/AdminManual.vue");
const ComponentSearchPage = () => import("@/views/pages/Search.vue");

const routes = [
  // Rota de teste simples
  {
    path: "/",
    name: "Home",
    component: Home,
  },

  // Rotas públicas com layout
  {
    path: "/categoria/:id",
    name: "CategoriaProdutos",
    component: CategoriaProdutos,
    props: true,
  },
  {
    path: "/produto/:nome",
    name: "ManualProduto",
    component: ManualProduto,
    props: (route) => ({ nome: route.params.nome, id: route.meta.id }),
  },

  // Rota de login
  {
    path: "/admin",
    name: "AdminLogin",
    component: Login,
  },

  // Rotas protegidas (com autenticação)
  {
    path: "/admin/produtos",
    name: "AdminProdutos",
    component: AdminProdutos,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/categorias",
    name: "AdminCategorias",
    component: AdminCategorias,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/categoria/:id?",
    name: "AdminCategoria",
    component: AdminCategoria,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/produto/:id?",
    name: "AdminProduto",
    component: AdminProduto,
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/manual/:id?",
    name: "AdminManual",
    component: AdminManual,
    props: true,
    meta: { requiresAuth: true },
  },
  // Rota Buscador
  {
    path: "/busca",
    name: "Busca",
    component: ComponentSearchPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const auth = useAuthStore();

  // Verifica se a rota de destino começa com /admin
  if (to.path.startsWith('/admin')) {
    // A rota de login do admin é uma exceção, não precisa de verificação
    if (to.name === 'AdminLogin') {
      return next();
    }

    const isSessaoValida = await auth.verificarSessao();

    if (isSessaoValida) {
      // Se a sessão for válida, permite o acesso à página solicitada.
      next();
    } else {
      // Se a sessão for inválida, redireciona para a página de login.
      next({ name: 'AdminLogin' });
    }
  } else {
    next();
  }
});

export default router;
